module.exports = __webpack_public_path__ + "static/img/noData_icon.5073f74b.png";